/**
 * PropertyCGI Studio credit pricing — TS source of truth.
 * Mirror defaults in property_cgi_settings + property_cgi_credit_cost() SQL.
 */

export const PROPERTYCGI_CREDIT_COST_1K = 5;
export const PROPERTYCGI_CREDIT_COST_2K = 10;
export const PROPERTYCGI_CREDIT_COST_4K = 15;
export const PROPERTYCGI_CREDIT_COST_EDIT = 5;

export const PROPERTYCGI_DEFAULT_MODEL = 'gemini-3.1-flash-image';

export const PROPERTYCGI_SUPPORTED_RESOLUTIONS = ['1K', '2K', '4K'] as const;

export type PropertyCgiResolution = (typeof PROPERTYCGI_SUPPORTED_RESOLUTIONS)[number];

export function propertyCgiCreditCost(
  resolution: PropertyCgiResolution | string,
  kind: 'initial' | 'variation' | 'refinement' | 'selective_edit' = 'initial',
): number {
  if (kind === 'selective_edit') return PROPERTYCGI_CREDIT_COST_EDIT;
  switch (String(resolution).toUpperCase()) {
    case '2K':
      return PROPERTYCGI_CREDIT_COST_2K;
    case '4K':
      return PROPERTYCGI_CREDIT_COST_4K;
    default:
      return PROPERTYCGI_CREDIT_COST_1K;
  }
}
